import axios from 'axios';

import { API_URL } from '../config/apiConfig';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401) {
      console.error('Authentication error:', error.response?.data?.error || 'Please authenticate');
    }
    
    return Promise.reject(
      new Error(error.response?.data?.error || error.message || 'An error occurred')
    );
  }
);

export const getAllProjects = async (page = 1, limit = 25, sortField = 'name', sortDirection = 'asc') => {
  try {
    const data = await api.get(
      `/api/projects?page=${page}&limit=${limit}&sortField=${sortField}&sortDirection=${sortDirection}`
    );
    return data;
  } catch (error) {
    console.error('Error in getAllProjects:', error);
    throw error;
  }
};

// Get all projects without pagination (for dropdowns and other full lists)
export const getAllProjectsNoPagination = async () => {
  try {
    const data = await api.get('/api/projects?noPagination=true');
    return data;
  } catch (error) {
    console.error('Error in getAllProjects:', error);
    throw error;
  }
};

export const getAssignedProjects = async () => {
  try {
    const data = await api.get('/api/projects/assigned');
    return data;
  } catch (error) {
    console.error('Error in getAssignedProjects:', error);
    throw error;
  }
};

export const getProject = async (id) => {
  try {
    const data = await api.get(`/api/projects/${id}`);
    return data;
  } catch (error) {
    console.error('Error in getProject:', error);
    throw error;
  }
};

export const createProject = async (projectData) => {
  try {
    const data = await api.post('/api/projects', projectData);
    return data;
  } catch (error) {
    console.error('Error in createProject:', error);
    throw error;
  }
};

export const updateProject = async (id, projectData) => {
  try {
    const data = await api.patch(`/api/projects/${id}`, projectData);
    return data;
  } catch (error) {
    console.error('Error in updateProject:', error);
    throw error;
  }
};

export const deleteProject = async (id) => {
  try {
    const data = await api.delete(`/api/projects/${id}`);
    return data;
  } catch (error) {
    console.error('Error in deleteProject:', error);
    throw error;
  }
};

// Get all distinct projects a user has timecards for (admin/team lead only)
export const getUserTimecardProjects = async (userId) => {
  try {
    const data = await api.get(`/api/projects/user-timecard-projects/${userId}`);
    return data;
  } catch (error) {
    console.error('Error in getUserTimecardProjects:', error);
    throw error;
  }
};
